import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { LoadLayerDialogService, LoadLayerParams } from './load-layer-dialog-service';
import { LayerLoadOptions } from 'src/app/model/api-services/layer-api.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';

@Component({
	selector: 'app-load-layer-dialog',
	templateUrl: './load-layer-dialog.component.html',
	styleUrls: ['./load-layer-dialog.component.scss']
})
export class LoadLayerDialogComponent implements OnInit {

	public title = 'Load Layer';
	public options: LayerLoadOptions = {
		target: 'player',
		properties: true,
		classification: true,
		labelStyle: true,
		tooltip_rich: true,
		tooltip: true
	};
	@HostBinding('class.work-view') workView = true;

	private layer: SLLayer;
	constructor(private messager: ModalMessagerService, private activeModal: NgbActiveModal) { }

	ngOnInit() {

	}
	Show(params: LoadLayerParams) {
		this.layer = params.layer;
	}
	Load(): void {
		if (this.options.target === 'layer') {
			this.messager.Confirm(
				'Loading from layer defaults will modify this map layer on ' +
				'the server prior to retrieving and updating the layer in the viewer, ' +
				'this cannot be undone. Do you wish to continue?', () => {
					this.LoadLayerInfo();
				}, () => { });
		} else {
			this.LoadLayerInfo();
		}


	}
	private LoadLayerInfo() {
		const message = 'Loading layer ' + this.layer.name;
		this.messager.Progress('Retrieving layer', false, 33, message);
		this.layer.Load(this.options).then((response) => {
			if (!!response.status) {
				if (response.status === 'ok') {
					this.messager.Progress('Retrieved, updating layer ...', true, 66, message);
					this.UpdateLayer(response.layer, message);

				} else {
					this.messager.Progress('There was  a problem', true, 100, message);
					this.messager.CancelProgress(message);
					this.messager.Notify('There was a problem retrieving layer information', true);
				}
			}
		});
	}
	UpdateLayer(info, message) {
		if (this.options.properties === true) {
			if (!!info.labels) {
				if (!!info.labels.labels_on) { this.layer.labelsOn = info.labels.labels_on; }
				if (!!info.labels.attribute) { this.layer.labelAttribute = info.labels.attribute; }
				if (this.options.labelStyle) {
					if (!!info.labels.labelStyle) { this.layer.labelStyle = info.labels.label_style; }
				}
			}
			if (!!info.searchTip) { this.layer.searchTip = info.searchTip; }
			if (!!info.tooltip) {
				if (!!info.tooltip.tooltip_on) { this.layer.tooltipOn = info.tooltip.tooltip_on === 1; }
				if (!!info.tooltip.vlue) { this.layer.tooltip = info.tooltip.value; }
			}
		}
		this.layer.CaptureLabelState();
		this.messager.Progress('Layer updated', true, 100, message);

	}
	LoadDefault(): void {

	}
	Cancel(): void {
		this.activeModal.close();
	}
}


@Component({
	selector: 'app-load-layer-dialog-entry',
	template: ''
})
export class LoadLayerDialogEntryComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: LoadLayerDialogService) {

		this.subscriptionMgr.Subscribe(this.service.request$, (info: any) => {
			this.modalRef = this.modalService.open(LoadLayerDialogComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as LoadLayerDialogComponent).Show(info);
		});
	}
	ngOnDestroy(): void {
		this.subscriptionMgr.CancelSubscriptions();
	}
}
